<template>
  <div>
    <a-card title="月度目标" :bordered="false" :loading="loading" style="margin-bottom:1rem">
      <div class="info" slot="extra">
        <span><cite>目标量</cite></span>
        <span><cite>完成量</cite></span>
      </div>
      <h3 class="d-flex justify-content-between">
        <div>订单金额</div>
        <div v-if="analysis && analysis.month && analysis.month.money">
          完成度：{{ ((analysis.month.money.now / analysis.month.money.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.month && analysis.month.money"
        :total="parseFloat(analysis.month.money.total)"
        :value="parseFloat(analysis.month.money.now)"
        :stroke-color="['#539EFF', '#B56DFF']"
      />
      <h3 class="d-flex justify-content-between">
        <div>uv</div>
        <div v-if="analysis && analysis.month && analysis.month.uv">
          完成度：{{ ((analysis.month.uv.now / analysis.month.uv.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.month && analysis.month.uv"
        :total="parseFloat(analysis.month.uv.total)"
        :value="parseFloat(analysis.month.uv.now)"
        :stroke-color="['#539EFF', '#B56DFF']"
      />
      <h3 class="d-flex justify-content-between">
        <div>注册量</div>
        <div v-if="analysis && analysis.month && analysis.month.zcl">
          完成度：{{ ((analysis.month.zcl.now / analysis.month.zcl.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.month && analysis.month.zcl"
        :total="parseFloat(analysis.month.zcl.total)"
        :value="parseFloat(analysis.month.zcl.now)"
        :stroke-color="['#539EFF', '#B56DFF']"
      />
      <h3 class="d-flex justify-content-between">
        <div>转化率</div>
        <div v-if="analysis && analysis.month && analysis.month.zhl">
          完成度：{{ ((analysis.month.zhl.now / analysis.month.zhl.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.month && analysis.month.zhl"
        :total="parseFloat(analysis.month.zhl.total)"
        :value="parseFloat(analysis.month.zhl.now)"
        :stroke-color="['#539EFF', '#B56DFF']"
      />
    </a-card>
    <a-card title="季度目标" :bordered="false" :loading="loading" style="margin-bottom:1rem">
      <div class="info quarter" slot="extra">
        <span><cite>目标量</cite></span>
        <span><cite>完成量</cite></span>
      </div>
      <h3 class="d-flex justify-content-between">
        <div>订单金额</div>
        <div v-if="analysis && analysis.quarter && analysis.quarter.money">
          完成度：{{ ((analysis.quarter.money.now / analysis.quarter.money.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.quarter && analysis.quarter.money"
        :total="parseFloat(analysis.quarter.money.total)"
        :value="parseFloat(analysis.quarter.money.now)"
        :stroke-color="['#108ee9', '#87d068']"
      />
      <h3 class="d-flex justify-content-between">
        <div>uv</div>
        <div v-if="analysis && analysis.quarter && analysis.quarter.uv">
          完成度：{{ ((analysis.quarter.uv.now / analysis.quarter.uv.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.quarter && analysis.quarter.uv"
        :total="parseFloat(analysis.quarter.uv.total)"
        :value="parseFloat(analysis.quarter.uv.now)"
        :stroke-color="['#108ee9', '#87d068']"
      />
      <h3 class="d-flex justify-content-between">
        <div>注册量</div>
        <div v-if="analysis && analysis.quarter && analysis.quarter.zcl">
          完成度：{{ ((analysis.quarter.zcl.now / analysis.quarter.zcl.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.quarter && analysis.quarter.zcl"
        :total="parseFloat(analysis.quarter.zcl.total)"
        :value="parseFloat(analysis.quarter.zcl.now)"
        :stroke-color="['#108ee9', '#87d068']"
      />
      <h3 class="d-flex justify-content-between">
        <div>转化率</div>
        <div v-if="analysis && analysis.quarter && analysis.quarter.zhl">
          完成度：{{ ((analysis.quarter.zhl.now / analysis.quarter.zhl.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.quarter && analysis.quarter.zhl"
        :total="parseFloat(analysis.quarter.zhl.total)"
        :value="parseFloat(analysis.quarter.zhl.now)"
        :stroke-color="['#108ee9', '#87d068']"
      />
    </a-card>
    <a-card title="年度目标" :bordered="false" :loading="loading" style="margin-bottom:1rem">
      <div class="info year" slot="extra">
        <span><cite>目标量</cite></span>
        <span><cite>完成量</cite></span>
      </div>
      <h3 class="d-flex justify-content-between">
        <div>订单金额</div>
        <div v-if="analysis && analysis.year && analysis.year.money">
          完成度：{{ ((analysis.year.money.now / analysis.year.money.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.year && analysis.year.money"
        :total="parseFloat(analysis.year.money.total)"
        :value="parseFloat(analysis.year.money.now)"
      />
      <h3 class="d-flex justify-content-between">
        <div>uv</div>
        <div v-if="analysis && analysis.year && analysis.year.uv">
          完成度：{{ ((analysis.year.uv.now / analysis.year.uv.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.year && analysis.year.uv"
        :total="parseFloat(analysis.year.uv.total)"
        :value="parseFloat(analysis.year.uv.now)"
      />
      <h3 class="d-flex justify-content-between">
        <div>注册量</div>
        <div v-if="analysis && analysis.year && analysis.year.zcl">
          完成度：{{ ((analysis.year.zcl.now / analysis.year.zcl.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.year && analysis.year.zcl"
        :total="parseFloat(analysis.year.zcl.total)"
        :value="parseFloat(analysis.year.zcl.now)"
      />
      <h3 class="d-flex justify-content-between">
        <div>转化率</div>
        <div v-if="analysis && analysis.year && analysis.year.zhl">
          完成度：{{ ((analysis.year.zhl.now / analysis.year.zhl.total) * 100).toFixed(2) }} %
        </div>
      </h3>
      <my-progress
        v-if="analysis && analysis.year && analysis.year.zhl"
        :total="parseFloat(analysis.year.zhl.total)"
        :value="parseFloat(analysis.year.zhl.now)"
      />
    </a-card>
  </div>
</template>

<script>
import { Progress } from '@/components'
import { requestGet } from '@/api/api'

export default {
    name: 'Analysis',
    components: {
        MyProgress: Progress
    },
    data () {
        return {
            loading: false,
            analysis: {}
        }
    },
    mounted () {
        this.getAnalysis()
    },
    methods: {
        getAnalysis () {
            this.loading = true
            requestGet('/analysis/okr')
                .then(res => {
                    this.analysis = res.result
                })
                .catch(err => {
                    this.$notification.error(err.message)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style lang="less" scoped>
h3 {
    margin-top: 15px;
    div {
        &:last-child {
            color: #aaa;
            font-style: normal;
            font-size: 0.75rem;
        }
    }
}
.info {
    span {
        padding-left: 60px;
        position: relative;
        margin-left: 15px;
        &::before {
            position: absolute;
            left: 0;
            top: 0;
            width: 60px;
            height: 20px;
            content: '';
            background: #f7f7f7;
            border-right: 60px;
        }
        &:last-child {
            &::before {
                background: linear-gradient(to right, rgb(83, 158, 255), rgb(181, 109, 255));
            }
        }
        cite {
            font-style: normal;
            margin-left: 15px;
        }
    }
    &.quarter {
        span {
            &:last-child {
                &::before {
                    background: linear-gradient(to right, rgb(16, 142, 233), rgb(135, 208, 104));
                }
            }
        }
    }
    &.year {
        span {
            &:last-child {
                &::before {
                    background: #52c41a;
                }
            }
        }
    }
}
</style>
